import React from 'react'
import { Column, SoapInputWrapper, Retry, RetryLoading } from './index.styled'
import { useNotesView } from './useNotesView'
import SoapInput from '../../../../components/SoapInput/SoapInput'
import reload from '../../../../images/retryNotes.svg'

export default function NotesViewPanel() {
  const {
    subjective,
    objective,
    assessment,
    plan,
    isReadOnly,
    handleSubjectiveChange,
    handleObjectiveChange,
    handleAssessmentChange,
    handlePlanChange,
    handleRetrySubjective,
    handleRetryObjective,
    handleRetryAssessment,
    handleRetryPlan,
    isRetryingSubjective,
    isRetryingObjective,
    isRetryingAssessment,
    isRetryingPlan,
    hasSelectedNote,
  } = useNotesView()

  return (
    <Column>
      <SoapInputWrapper>
        <SoapInput label="S" value={subjective} onChange={handleSubjectiveChange} readOnly={isReadOnly} />
        {hasSelectedNote &&
          !isReadOnly &&
          !subjective &&
          (isRetryingSubjective ? (
            <RetryLoading src={reload} alt="Retrying" />
          ) : (
            <Retry src={reload} alt="Retry" onClick={handleRetrySubjective} />
          ))}
      </SoapInputWrapper>

      <SoapInputWrapper>
        <SoapInput label="O" value={objective} onChange={handleObjectiveChange} readOnly={isReadOnly} />
        {hasSelectedNote &&
          !isReadOnly &&
          !objective &&
          (isRetryingObjective ? (
            <RetryLoading src={reload} alt="Retrying" />
          ) : (
            <Retry src={reload} alt="Retry" onClick={handleRetryObjective} />
          ))}
      </SoapInputWrapper>

      <SoapInputWrapper>
        <SoapInput label="A" value={assessment} onChange={handleAssessmentChange} readOnly={isReadOnly} />
        {hasSelectedNote &&
          !isReadOnly &&
          !assessment &&
          (isRetryingAssessment ? (
            <RetryLoading src={reload} alt="Retrying" />
          ) : (
            <Retry src={reload} alt="Retry" onClick={handleRetryAssessment} />
          ))}
      </SoapInputWrapper>

      <SoapInputWrapper>
        <SoapInput label="P" value={plan} onChange={handlePlanChange} readOnly={isReadOnly} />
        {hasSelectedNote &&
          !isReadOnly &&
          !plan &&
          (isRetryingPlan ? (
            <RetryLoading src={reload} alt="Retrying" />
          ) : (
            <Retry src={reload} alt="Retry" onClick={handleRetryPlan} />
          ))}
      </SoapInputWrapper>
    </Column>
  )
}
